<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M40.089 17.767a.008.008 0 0 1-.008-.008 1.266 1.266 0 0 0-.469-.459l-6.876-3.868a1.25 1.25 0 0 0-1.219 0L24.642 17.3a1.266 1.266 0 0 0-.469.459.008.008 0 0 1-.008.008v.016a1.172 1.172 0 0 0-.164.6v7.7a1.258 1.258 0 0 0 .641 1.094l6.876 3.868a1.289 1.289 0 0 0 .563.156h.109a1.258 1.258 0 0 0 .547-.156l6.876-3.868a1.258 1.258 0 0 0 .641-1.094v-7.7a1.219 1.219 0 0 0-.165-.616zm-7.889 3.75-6.29-3.5 6.22-3.5 6.228 3.5zm6.8 4.571L32.76 29.6l.066-7 6.181-3.516z" style="fill:#517dfb" transform="translate(-22.125 -12.238)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-tutorial02',
});
</script>
